import React from 'react';
import { observer } from "mobx-react"
import ewtStore from '../EWTStore';
import Pairings from './Pairings';
import {Modal} from 'antd';
import {reaction} from 'mobx';
import {PlusOutlined,MinusOutlined,RightSquareFilled,LeftSquareFilled,PictureOutlined} from '@ant-design/icons';
import { StickyTable, Row, Cell } from 'react-sticky-table';
import CourseCard from './CourseCard';
import { theme, ewtModalClass, modalStyle, tableCellHeader } from '../theme';

const getScoringCourse = (roundID) => {
	if (!roundID || !ewtStore.rounds) return null;
	const round = ewtStore.rounds[roundID];
	if (!round || !round.courseID) return null;
	if (ewtStore.course && ewtStore.course.id === round.courseID) {
		return ewtStore.course;
	}
	if (!ewtStore.courses) return null;
	return ewtStore.courses[round.courseID] || null;
};

const scoreBtnStyle = {
	width: 36,
	height: 36,
	marginTop: 10,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	cursor: 'pointer',
	color: '#6BA3E0',
	fontSize: 20,
	borderRadius: 8,
	border: '1px solid #BFDBFE',
	backgroundColor: theme.leaderRow,
};

const Scoring = observer(class Scoring extends React.Component {

	constructor(props) {
		super(props);
		this.changeScore = this.changeScore.bind(this);
		this.changeHole = this.changeHole.bind(this);
		this.closeRound = this.closeRound.bind(this);
		this.roundChanged = this.roundChanged.bind(this);
		this.disposeCurrentRoundReaction = reaction(
			() => ewtStore.currentRoundID,
			(currentRoundID) => {
				if (!this._isMounted) return;
				this.setState({
					roundID: currentRoundID,
					course: getScoringCourse(currentRoundID),
					currentHole: ewtStore.calcGroupScoringHole(currentRoundID),
				});
			}
		);
		this.disposeCourseReaction = reaction(
			() => {
				const roundID = ewtStore.currentRoundID;
				return getScoringCourse(roundID);
			},
			(course) => {
				if (!this._isMounted || !course) return;
				if (this.state.course !== course) {
					this.setState({ course });
				}
			}
		);
		this.state = {currentHole:1,currentHoleScores:{},showSelectHole:false,endRound:false,roundID:ewtStore.currentRoundID,holeMapURL:null,course:getScoringCourse(ewtStore.currentRoundID)}
	}

	componentDidMount() {
		this._isMounted = true;
		this.setState({ currentHole: ewtStore.calcGroupScoringHole(this.state.roundID) });
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.disposeCurrentRoundReaction) this.disposeCurrentRoundReaction();
		if (this.disposeCourseReaction) this.disposeCourseReaction();
	}

	closeRound() {
		this.setState({endRound:false})
	}

	changeHole(increment, hole) {
		this.setState({ showSelectHole: false });
		const roundID = this.state.roundID;
		const startHole = ewtStore.getGroupStartingHole(roundID);
		const currentHole = this.state.currentHole;
		const lastHole = ewtStore.getLastHoleInPlayOrder(startHole);

		if (hole) {
			const selectable = ewtStore.getSelectableScoringHoles(roundID);
			if (selectable.indexOf(hole) >= 0) {
				this.setState({ currentHole: hole });
			}
			return;
		}

		if (increment < 0) {
			if (currentHole === startHole) return;
			const prev = ewtStore.getPrevHoleInPlayOrder(currentHole, startHole);
			if (prev) this.setState({ currentHole: prev });
			return;
		}

		if (increment > 0) {
			if (currentHole === lastHole) {
				this.setState({ endRound: true });
				return;
			}
			const next = ewtStore.getNextHoleInPlayOrder(currentHole, startHole);
			if (next) this.setState({ currentHole: next });
		}
	}

	changeScore(playerID,increment) {
		var roundID = this.state.roundID;
		if (ewtStore.roundScores[roundID] && ewtStore.roundScores[roundID][playerID] && ewtStore.roundScores[roundID][playerID][this.state.currentHole]) {
			var score = ewtStore.roundScores[roundID][playerID][this.state.currentHole];
			if (increment === -1 && score.score === 1) {
				ewtStore.deleteScore({
					roundID,
					playerID,
					num: this.state.currentHole,
				});
				return;
			}
			score.score += increment;
			ewtStore.setScore(roundID,playerID,this.state.currentHole,score.score);
			// score = ewtStore.roundScores[ewtStore.roundID][playerID][this.state.currentHole];
			// score.score += increment;
			// if (score.score < 1) score.score = 1;
			// ewtStore.firebaseDB.collection("scores").doc(score.id).update({
			// 	score:score.score
			// });
		} else { //add new record
			var par = this.state.course.holes[this.state.currentHole].tees[ewtStore.rounds[roundID].tees].par;
			ewtStore.setScore(roundID,playerID,this.state.currentHole,par);
			// score = {roundID:roundID,playerID:playerID,hole:this.state.currentHole,tournamentID:ewtStore.tournament.id,score:par}
			// ewtStore.firebaseDB.collection("scores").add(score);
		}
		// if (increment === 0) {
		// 	this.setState({currentHole:this.state.currentHole+1})
		// }
		return;


		// if (increment === -1 && this.state.currentHoleScores[playerID] === 1) return;
		// var currentHoleScores = this.state.currentHoleScores;
		// currentHoleScores[playerID] += increment;
		// this.setState({currentHoleScores:currentHoleScores});
		// var playerIDs = [];
		// ewtStore.groupPlayers.forEach((player) => {
		// 	playerIDs.push(player.id);
		// })
		// //try and get the scores for this hole, update the ones found, otherwise create them
		// ewtStore.firebaseDB.collection("scores").where("roundID","==",ewtStore.rounds[ewtStore.currentRoundID].id).where("hole","==",this.state.currentHole).where("playerID","in",playerIDs).where("tournamentID","==",ewtStore.tournament.id).get()
		// .then(function(querySnapshot) {
		// 	var batch = ewtStore.firebaseDB.batch();
		// 	var foundScores = {};
		// 	querySnapshot.forEach(function(doc) {
		// 		var rec = doc.data();
		// 		rec.id = doc.id;
		// 		if (rec.score !== currentHoleScores[rec.playerID]) {
		// 			rec.score = currentHoleScores[rec.playerID];
		// 			var ref = ewtStore.firebaseDB.collection("scores").doc(rec.id);
		// 			batch.set(ref,rec);
		// 		}
		// 		foundScores[rec.playerID] = true;
		// 	})
		// 	playerIDs.forEach((playerID) => {
		// 		if (!foundScores[playerID]) { //need to create one
		// 			var rec = {roundID:ewtStore.rounds[ewtStore.currentRoundID].id,tournamentID:ewtStore.tournament.id,playerID:playerID,hole:this.state.currentHole,score:currentHoleScores[playerID]}
		// 			var ref = ewtStore.firebaseDB.collection("scores").doc();
		// 			batch.set(ref,rec);
		// 		}
		// 	})
		// 	batch.commit();
		// 	if (increment === 0) ewtStore.setCurrentHole(this.state.currentHole + 1,true);
		// });
		
	}
	roundChanged(roundID) {
		this.setState({
			roundID: roundID,
			currentHole: ewtStore.calcGroupScoringHole(roundID),
		});
	}

	render() {

		if (!ewtStore.initialized) {
			return <div></div>
		}

		var round = ewtStore.rounds[this.state.roundID];
		if (!round) {
			return (
				<div
					className="flexColumn flexGrow cupPanel"
					style={{
						height: ewtStore.panelHeight,
						justifyContent: 'center',
						alignItems: 'center',
						width: '100%',
						maxWidth: '100%',
						padding: '0 8px 8px 8px',
						boxSizing: 'border-box',
					}}
				>
					<div style={{ padding: 20, fontSize: 18, textAlign: 'center', color: theme.slate }}>
						No rounds configured for this tournament.
					</div>
				</div>
			);
		}

		const course =
			this.state.course ||
			getScoringCourse(this.state.roundID) ||
			ewtStore.course;
		const currentHole = this.state.currentHole;
		const holeData =
			course &&
			course.holes &&
			course.holes[currentHole] &&
			course.holes[currentHole].tees &&
			course.holes[currentHole].tees[round.tees];

		var showHoles = [];
		if (course) {
			showHoles = ewtStore.getSelectableScoringHoles(this.state.roundID);
		}

		const isActiveScoring = round.open && !round.finalized;
		if (isActiveScoring && (!course || !holeData)) {
			return <div></div>;
		}
		const scoringPanelWidth = Math.min(400, ewtStore.panelWidth || 400);

		const getHoleTee = (holeNumber) =>
			course &&
			course.holes &&
			course.holes[holeNumber] &&
			course.holes[holeNumber].tees &&
			course.holes[holeNumber].tees[round.tees];

		const modals = (
			<>
				{this.state.showSelectHole && <Modal
					className={ewtModalClass}
					title="Select Hole"
					open={this.state.showSelectHole}
					onCancel={() => this.setState({showSelectHole:false})}
					bodyStyle={{margin:0,padding:0,height:window.innerHeight - 115}}
					style={modalStyle}
					closable={true}
					footer={null}
					>
					<div className="flexColumn flexGrow" style={{height:window.innerHeight - 120}}>
						<StickyTable border={0} style={{fontSize:theme.fontBase,width:'100%',tableLayout:'fixed'}}>
					  		<Row>
								<Cell style={tableCellHeader}>Hole</Cell>
								<Cell style={tableCellHeader}>Par</Cell>
								<Cell style={tableCellHeader}>Yards</Cell>
							</Row>
							{showHoles.map((key,index) => {
								const rowBg = index % 2 === 0 ? theme.surface : theme.surfaceAlt;
								const tee = getHoleTee(key);
								if (!tee) return null;
								return (
								<Row onClick={() => this.changeHole(0,key)} style={{cursor:'pointer'}} key={index}>
									<Cell style={{ borderBottom: `1px solid ${theme.border}`, textAlign: 'center', padding: '6px 4px', backgroundColor: rowBg, color: theme.navy }}>{key}</Cell>
									<Cell style={{ borderBottom: `1px solid ${theme.border}`, textAlign: 'center', padding: '6px 4px', backgroundColor: rowBg, color: theme.navy }}>{tee.par}</Cell>
									<Cell style={{ borderBottom: `1px solid ${theme.border}`, textAlign: 'center', padding: '6px 4px', backgroundColor: rowBg, color: theme.navy }}>{tee.yardage}</Cell>
								</Row>
								);
							})}
						</StickyTable>
					</div>
				</Modal>}
				<Modal
					className={ewtModalClass}
					title="Confirm Round Complete"
					open={this.state.endRound}
					onCancel={() => this.setState({endRound:false})}
					onOk={()=> this.closeRound()}
					bodyStyle={{margin:0,padding:16}}
					style={modalStyle}
					closable={false}
					>
				</Modal>
			</>
		);

		if (isActiveScoring) {
			return (
				<>
					<div className="flexRow flexGrow" style={{ width: '100%', justifyContent: 'center', alignItems: 'flex-start' }}>
						<div
							className="flexColumn noselect cupPanel cupPanel--flush"
							style={{
								width: scoringPanelWidth,
								maxWidth: '100%',
								padding: '0 8px 8px 8px',
								boxSizing: 'border-box',
								flexGrow: 0,
							}}
						>
							<div className="flexColumn" style={{ width: '100%', padding: '4px 0' }}>
								<div className="flexRow" style={{ verticalAlign: 'middle', width: '100%', fontSize: 34, padding: '8px 5px', cursor: 'pointer', borderRadius: 8, height: 60, backgroundColor: theme.surfaceAlt, color: theme.navy, borderBottom: `1px solid ${theme.border}` }}>
									<div style={{ width: 50, fontSize: 36, padding: 5, marginTop: -5, cursor: 'pointer', color: theme.brandBlue }} onClick={() => this.changeHole(-1)}>
										<LeftSquareFilled></LeftSquareFilled>
									</div>
									<div className="flexGrow" style={{ textAlign: 'center', fontWeight: 600 }}>
										<span onClick={() => this.setState({showSelectHole:true})}>Hole&nbsp;{this.state.currentHole}&nbsp;</span>
										<PictureOutlined
											style={{ marginLeft: 8, fontSize: 26, color: theme.brandBlue, verticalAlign: 'middle', cursor: 'pointer' }}
											onClick={(e) => { e.stopPropagation(); ewtStore.showHoleMap(this.state.currentHole); }}
										/>
									</div>
									<div style={{ width: 50, fontSize: 36, padding: 5, marginTop: -5, cursor: 'pointer', color: theme.brandBlue }} onClick={() => this.changeHole(1)}>
										<RightSquareFilled></RightSquareFilled>
									</div>
								</div>

								<div className="flexColumn" style={{ padding: '8px 5px', marginTop: 0 }}>
									{ewtStore.groupPlayers && ewtStore.groupPlayers.map((player,index) => {
										var numStrokes = Math.abs(ewtStore.getNet(player.id,course,round,currentHole,holeData.par));
										return (
										<div key={index} className="flexRow" style={{ height: 60, borderBottom: index < ewtStore.groupPlayers.length - 1 ? `1px solid ${theme.border}` : 'none' }}>
											<div className="flexColumn" style={{ width: 150, fontSize: 24, marginTop: 15, cursor: 'pointer', color: theme.navy, fontWeight: 500 }} onClick={() => {player.showRound = round;ewtStore.showPlayerCard = player}}>
												{ewtStore.players[player.id].shortName}
												<div style={{marginTop:-30,marginLeft:3,height:10}} className="flexRow">
													{numStrokes > 0 && <span><u>&nbsp;&nbsp;</u>&nbsp;&nbsp;</span>}
													{numStrokes > 1 && <span><u>&nbsp;&nbsp;</u>&nbsp;&nbsp;</span>}
													{numStrokes > 2 && <span><u>&nbsp;&nbsp;</u></span>}
												</div>
											</div>
											<div style={scoreBtnStyle} onClick={() => this.changeScore(player.id,-1)}><MinusOutlined /></div>
											<div style={{ width: 45, fontSize: 34, textAlign: 'center', marginTop: 5, fontWeight: 600, color: theme.navy }}>
												{ewtStore.roundScores[this.state.roundID] && ewtStore.roundScores[this.state.roundID][player.id] && ewtStore.roundScores[this.state.roundID][player.id][currentHole] && ewtStore.roundScores[this.state.roundID][player.id][currentHole].score}
											</div>
											<div style={scoreBtnStyle} onClick={() => this.changeScore(player.id,1)}><PlusOutlined /></div>
										</div>
										)
									})}
								</div>
								<div className="flexRow" style={{ height: 45, backgroundColor: theme.surfaceAlt, fontSize: 22, padding: '8px 10px', color: theme.slate, marginBottom: 0, borderRadius: 8, borderTop: `1px solid ${theme.border}` }}>
									<div>Par {holeData.par}</div>
									<div className="flexGrow" style={{ textAlign: 'center' }}>{holeData.yardage}&nbsp;yards</div>
									<div>hcp&nbsp;#{holeData.handicap}</div>
								</div>
							</div>
						</div>
					</div>
					{modals}
				</>
			);
		}

		return (
			<>
			<div
				className="flexColumn flexGrow cupPanel cupPanel--flush cupPanel--bleed"
				style={{
					flex: 1,
					width: '100%',
					minHeight: 0,
					overflow: 'hidden',
					padding: '0 8px 8px 8px',
					boxSizing: 'border-box',
				}}
			>
				<div className="flexColumn flexGrow cupTableGap" style={{ width: '100%', minWidth: 0, minHeight: 0, flex: 1 }}>
					{round.finalized && <CourseCard roundID={this.state.roundID}></CourseCard>}
					{!round.finalized && !round.open && <Pairings></Pairings>}
				</div>
			</div>
			{modals}
			</>
	  );
	}
});


export default Scoring;